import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IIdItemInfo, ILuidItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';

export type FlowWithRunPermission = IIdItemInfo & ILuidItemInfo & {
  name: string;
  userHasRunPermissions: boolean;
}

export type GetFlowsWithRunPermissionsParams = IGetItemsParams;

export type GetFlowsWithRunPermissionsResult = IGetItemsResult & {
  contents?: FlowWithRunPermission[];
}

export class GetFlowsWithRunPermissionsRequest extends Request<GetFlowsWithRunPermissionsParams, GetFlowsWithRunPermissionsResult> {
  constructor(params: GetFlowsWithRunPermissionsParams) {
    super('getFlowsWithRunPermissions', params);
  }
}
